import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {Redirect} from "react-router";
import {WorkspaceStore} from "../../../stores/WorkspaceStore";
import {lazyInject} from "@intelingu/core/IoC/container";
import {AuthStore} from "../../../stores/AuthStore";

interface LogoutPageProps {
}

@observer export class LogoutPage extends Component<LogoutPageProps, any> {

    @lazyInject(WorkspaceStore) workspaceStore: WorkspaceStore;
    @lazyInject(AuthStore) authStore: AuthStore;

    componentWillUnmount(): void {
        this.workspaceStore.user = null;
        this.authStore.resetToken();

        localStorage.removeItem("courseId");
    }

    render() {
        return <Redirect to={`/session/login`} />
    }

}
